import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getAnalytics, Analytics } from 'firebase/analytics';

// Firebase configuration
// HiveTrack UK Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyBKdfn8SGRiYLC1VsWgbCj5_wFNQsdq3_4",
  authDomain: "hivetrack-uk-25.firebaseapp.com",
  projectId: "hivetrack-uk-25",
  storageBucket: "hivetrack-uk-25.firebasestorage.app",
  messagingSenderId: "1060351093027",
  appId: "1:1060351093027:web:643143a9aa181f33020496",
  measurementId: "G-86KPV6KX4K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'europe-west2'); // GDPR-compliant region

// Initialize Analytics (only in browser environment)
export let analytics: Analytics | null = null;
if (typeof window !== 'undefined') {
  try {
    analytics = getAnalytics(app);
  } catch (error) {
    console.warn('Google Analytics initialization failed:', error);
  }
}

export default app;
